import { useState, useEffect } from 'react';
import { fetchSqlData } from '../../../services/api';
import { getBaseRoute } from './formUtils';

type FormGroup = {
  id: number;
  group_name: string;
  essential_field_names: string[];
};

export const useFormGroups = (pathname: string) => {
  const [formGroups, setFormGroups] = useState<FormGroup[]>([]);
  const [groupLoading, setGroupLoading] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState<number | null>(null);
  const [groupEssentialFields, setGroupEssentialFields] = useState<string[]>([]);

  useEffect(() => {
    const fetchGroups = async () => {
      setGroupLoading(true);
      try {
        const baseRoute = getBaseRoute(pathname);
        const data = await fetchSqlData('cor_form_groups', 'route_name', baseRoute);
        setFormGroups(Array.isArray(data) ? data : []);
      } catch {
        setFormGroups([]);
      } finally {
        setGroupLoading(false);
      }
    };
    fetchGroups();
  }, [pathname]);

  useEffect(() => {
    if (selectedGroupId !== null) {
      const group = formGroups.find(g => g.id === selectedGroupId);
      setGroupEssentialFields(group ? group.essential_field_names : []);
    } else {
      setGroupEssentialFields([]);
    }
  }, [selectedGroupId, formGroups]);

  return {
    formGroups,
    groupLoading,
    selectedGroupId,
    setSelectedGroupId,
    groupEssentialFields,
    isGroupSelected: selectedGroupId !== null,
  };
};